import type { AxiosInstance } from 'axios';
import type {
  ChartSection,
  ChartSectionListResponse,
  ListQueryParams,
  EntityId,
} from '@/types';

export const getChartSections = async (
  api: AxiosInstance,
  chart_id: EntityId,
  limit = 50,
  start_key: string | undefined = undefined,
  name: string | undefined = undefined,
): Promise<ChartSectionListResponse> => {
  const resp = await api.get<ChartSectionListResponse>(`/chart/${chart_id}/section`, {
    params: { limit, start_key, name } as ListQueryParams,
  });
  return resp.data;
};

export const getChartSection = async (
  api: AxiosInstance,
  chart_id: EntityId,
  section_id: EntityId,
): Promise<ChartSection> => {
  const resp = await api.get<ChartSection>(
    `/chart/${chart_id}/section/${section_id}`,
  );
  return resp.data;
};

export const createChartSection = async (
  api: AxiosInstance,
  chart_id: EntityId,
  values: Omit<ChartSection, 'entity_id' | 'created_at' | 'updated_at'>,
): Promise<ChartSection> => {
  const resp = await api.post<ChartSection>(`/chart/${chart_id}/section`, values);
  return resp.data;
};

export const updateChartSection = async (
  api: AxiosInstance,
  chart_id: EntityId,
  section_id: EntityId,
  values: Partial<Omit<ChartSection, 'entity_id' | 'created_at' | 'updated_at'>>,
): Promise<ChartSection> => {
  const resp = await api.put<ChartSection>(
    `/chart/${chart_id}/section/${section_id}`,
    values,
  );
  return resp.data;
};

export const deleteChartSection = async (
  api: AxiosInstance,
  chart_id: EntityId,
  section_id: EntityId,
): Promise<void> => {
  const resp = await api.delete(`/chart/${chart_id}/section/${section_id}`);
  return resp.data;
};

